// source: authz/roles.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.authz.AccessRolesRole', null, global);
goog.exportSymbol('proto.authz.AccountDetailsRole', null, global);
goog.exportSymbol('proto.authz.AccountSettingsRole', null, global);
goog.exportSymbol('proto.authz.AuditScanRole', null, global);
goog.exportSymbol('proto.authz.AuditsRole', null, global);
goog.exportSymbol('proto.authz.ChatsRole', null, global);
goog.exportSymbol('proto.authz.CompanyInfoRole', null, global);
goog.exportSymbol('proto.authz.ContentVersionsRole', null, global);
goog.exportSymbol('proto.authz.ControlsRole', null, global);
goog.exportSymbol('proto.authz.DashboardsRole', null, global);
goog.exportSymbol('proto.authz.DepartmentsRole', null, global);
goog.exportSymbol('proto.authz.EvidenceRole', null, global);
goog.exportSymbol('proto.authz.FrameworksRole', null, global);
goog.exportSymbol('proto.authz.GrcDocumentsRole', null, global);
goog.exportSymbol('proto.authz.PlaybooksRole', null, global);
goog.exportSymbol('proto.authz.PoliciesRole', null, global);
goog.exportSymbol('proto.authz.QuestionnairesRole', null, global);
goog.exportSymbol('proto.authz.ReceptorsRole', null, global);
goog.exportSymbol('proto.authz.ReportsRole', null, global);
goog.exportSymbol('proto.authz.RequestsRole', null, global);
goog.exportSymbol('proto.authz.RisksRole', null, global);
goog.exportSymbol('proto.authz.RoadmapRole', null, global);
goog.exportSymbol('proto.authz.SchedulesRole', null, global);
goog.exportSymbol('proto.authz.ScopeRole', null, global);
goog.exportSymbol('proto.authz.ServicesRole', null, global);
goog.exportSymbol('proto.authz.TrustPortalRole', null, global);
goog.exportSymbol('proto.authz.UsersRole', null, global);
goog.exportSymbol('proto.authz.VendorsRole', null, global);
/**
 * @enum {number}
 */
proto.authz.ControlsRole = {
  CONTROLS_UNSPECIFIED: 0,
  CONTROLS_NONE: 1,
  CONTROLS_EDITOR: 2,
  CONTROLS_EDITOR_IF_OWNER: 3,
  CONTROLS_READ_ONLY: 4
};

/**
 * @enum {number}
 */
proto.authz.PoliciesRole = {
  POLICIES_UNSPECIFIED: 0,
  POLICIES_NONE: 1,
  POLICIES_EDITOR: 2,
  POLICIES_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.EvidenceRole = {
  EVIDENCE_UNSPECIFIED: 0,
  EVIDENCE_NONE: 1,
  EVIDENCE_EDITOR: 2,
  EVIDENCE_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.RisksRole = {
  RISKS_UNSPECIFIED: 0,
  RISKS_NONE: 1,
  RISKS_EDITOR: 2,
  RISKS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.ServicesRole = {
  SERVICES_UNSPECIFIED: 0,
  SERVICES_NONE: 1,
  SERVICES_EDITOR: 2,
  SERVICES_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.ReceptorsRole = {
  RECEPTORS_UNSPECIFIED: 0,
  RECEPTORS_NONE: 1,
  RECEPTORS_EDITOR: 2,
  RECEPTORS_USER: 3,
  RECEPTORS_READ_ONLY: 4
};

/**
 * @enum {number}
 */
proto.authz.FrameworksRole = {
  FRAMEWORKSE_UNSPECIFIED: 0,
  FRAMEWORKS_NONE: 1,
  FRAMEWORKS_EDITOR: 2,
  FRAMEWORKS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.AuditsRole = {
  AUDITS_UNSPECIFIED: 0,
  AUDITS_NONE: 1,
  AUDITS_EDITOR: 2,
  AUDITS_AUDITOR: 3,
  AUDITS_READ_ONLY: 4,
  AUDITS_CC_USER: 5
};

/**
 * @enum {number}
 */
proto.authz.RequestsRole = {
  REQUESTS_UNSPECIFIED: 0,
  REQUESTS_NONE: 1,
  REQUESTS_EDITOR: 2,
  REQUESTS_AUDITOR: 3,
  REQUESTS_READ_ONLY: 4
};

/**
 * @enum {number}
 */
proto.authz.ReportsRole = {
  REPORTS_UNSPECIFIED: 0,
  REPORTS_NONE: 1,
  REPORTS_EDITOR: 2,
  REPORTS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.RoadmapRole = {
  ROADMAP_UNSPECIFIED: 0,
  ROADMAP_NONE: 1,
  ROADMAP_READ_ONLY: 2,
  ROADMAP_EDITOR: 3
};

/**
 * @enum {number}
 */
proto.authz.DashboardsRole = {
  DASHBOARDS_UNSPECIFIED: 0,
  DASHBOARDS_NONE: 1,
  DASHBOARDS_EDITOR: 2,
  DASHBOARDS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.UsersRole = {
  USERS_UNSPECIFIED: 0,
  USERS_NONE: 1,
  USERS_EDITOR: 2,
  USERS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.ScopeRole = {
  SCOPE_UNSPECIFIED: 0,
  SCOPE_NONE: 1,
  SCOPE_EDITOR: 2,
  SCOPE_LIMITED_EDITOR: 3,
  SCOPE_READ_ONLY: 4
};

/**
 * @enum {number}
 */
proto.authz.AccountDetailsRole = {
  ACCOUNT_DETAILS_UNSPECIFIED: 0,
  ACCOUNT_DETAILS_NONE: 1,
  ACCOUNT_DETAILS_READ_ONLY: 2
};

/**
 * @enum {number}
 */
proto.authz.AuditScanRole = {
  AUDIT_SCAN_UNSPECIFIED: 0,
  AUDIT_SCAN_NONE: 1,
  AUDIT_SCAN_EDITOR: 2,
  AUDIT_SCAN_READ_ONLY: 3,
  AUDIT_SCAN_ADMIN_EDITOR: 4
};

/**
 * @enum {number}
 */
proto.authz.ChatsRole = {
  CHATS_UNSPECIFIED: 0,
  CHATS_NONE: 1,
  CHATS_EDITOR: 2,
  CHATS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.TrustPortalRole = {
  TRUST_PORTAL_UNSPECIFIED: 0,
  TRUST_PORTAL_NONE: 1,
  TRUST_PORTAL_EDITOR: 2,
  TRUST_PORTAL_PUBLISHER: 3,
  TRUST_PORTAL_APPROVER: 4
};

/**
 * @enum {number}
 */
proto.authz.QuestionnairesRole = {
  QUESTIONNAIRES_UNSPECIFIED: 0,
  QUESTIONNAIRES_NONE: 1,
  QUESTIONNAIRES_EDITOR: 2,
  QUESTIONNAIRES_AUDITOR: 3,
  QUESTIONNAIRES_READ_ONLY: 4
};

/**
 * @enum {number}
 */
proto.authz.AccountSettingsRole = {
  ACCOUNT_SETTINGS_UNSPECIFIED: 0,
  ACCOUNT_SETTINGS_NONE: 1,
  ACCOUNT_SETTINGS_EDITOR: 2,
  ACCOUNT_SETTINGS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.VendorsRole = {
  VENDORS_UNSPECIFIED: 0,
  VENDORS_NONE: 1,
  VENDORS_EDITOR: 2,
  VENDORS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.GrcDocumentsRole = {
  GRC_DOCUMENTS_UNSPECIFIED: 0,
  GRC_DOCUMENTS_NONE: 1,
  GRC_DOCUMENTS_EDITOR: 2,
  GRC_DOCUMENTS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.PlaybooksRole = {
  PLAYBOOKS_UNSPECIFIED: 0,
  PLAYBOOKS_NONE: 1,
  PLAYBOOKS_EDITOR: 2,
  PLAYBOOKS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.AccessRolesRole = {
  ACCESS_ROLES_UNSPECIFIED: 0,
  ACCESS_ROLES_NONE: 1,
  ACCESS_ROLES_EDITOR: 2,
  ACCESS_ROLES_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.DepartmentsRole = {
  DEPARTMENTS_UNSPECIFIED: 0,
  DEPARTMENTS_NONE: 1,
  DEPARTMENTS_EDITOR: 2,
  DEPARTMENTS_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.CompanyInfoRole = {
  COMPANY_INFO_UNSPECIFIED: 0,
  COMPANY_INFO_NONE: 1,
  COMPANY_INFO_EDITOR: 2,
  COMPANY_INFO_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.SchedulesRole = {
  SCHEDULES_UNSPECIFIED: 0,
  SCHEDULES_NONE: 1,
  SCHEDULES_EDITOR: 2,
  SCHEDULES_READ_ONLY: 3
};

/**
 * @enum {number}
 */
proto.authz.ContentVersionsRole = {
  CONTENT_VERSIONS_UNSPECIFIED: 0,
  CONTENT_VERSIONS_NONE: 1,
  CONTENT_VERSIONS_PUBLISHER: 2,
  CONTENT_VERSIONS_UPGRADER: 3,
  CONTENT_VERSIONS_READ_ONLY: 4
};

goog.object.extend(exports, proto.authz);
